import { RouteConfig } from 'vue-router';
import { Routes } from '@/router/Routes';

const EthicQuizRoutes: RouteConfig = {
  path: 'ethics',
  component: () => import('../views/EthicNavigation.vue'),
  redirect: '/ethics/start',
  children: [
    {
      path: 'start',
      name: Routes.ETHIC_QUIZZ.START_ETHIC_QUIZZ,
      component: () => import('../views/EthicQuiz.vue'),
    },
  ],
}

export default EthicQuizRoutes; 